<template>
    <div>
        <Pdf :props="pdfUrl"></Pdf>
    </div>
</template>
<script>
import Pdf from "@/components/Pdf.vue"
export default {
    components: {
        Pdf
    },
    data() {
        return {
            pdfUrl: ""
        }
    }
}
</script>